import get from 'lodash/get';

import type { ExistingVolumeOptionItem } from './types';

export function mapExistingVolumeItems(items: unknown[]): ExistingVolumeOptionItem[] {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    label: get(item, 'spec.name') || get(item, 'metadata.name'),
    value: get(item, 'metadata.name'),
    size: get(item, 'spec.pvc.resources.requests.storage', '-'),
    storageClass: get(item, 'spec.pvc.storageClassName', '-'),
    origin: item,
  }));
}
